import InitialHoldStatus from "@/enums/initialHoldStatus";

export const getInitialHoldStatusText = (
  status: InitialHoldStatus
): InitialHoldStatus | "Active" => {
  return status === InitialHoldStatus.APPROVED ? "Active" : status;
};
